import React from "react";
import { useFormat } from "@loomstateorg/shared-frontend/hooks/useFormat";
import { ProductAvailabilityTagsProps } from "./types";
import { getTagConfig } from "./config";

const ProductAvailabilityTags = ({
    tags,
    wrapperClassName = "",
    tagClassName = "",
    tagClassNameByKey = {},
    layout = "inline",
}: ProductAvailabilityTagsProps): JSX.Element | null => {
    const { formatMessage } = useFormat({ name: "product" });

    if (!tags?.length) {
        return null;
    }

    return (
        <div
            className={`flex flex-wrap ${wrapperClassName} ${layout === "stacked" ? "flex-col gap-4" : "gap-8"}`}
            role="list"
            data-testid="availability-tag-list"
            aria-label={formatMessage({
                id: "product.availability.tags",
                defaultMessage: "Product availability information",
            })}
        >
            {tags.map((tag, index) => {
                const config = getTagConfig(tag.key);
                const displayLabel = config?.displayLabelKey
                    ? formatMessage({
                          id: config.displayLabelKey,
                          defaultMessage: tag.label || tag.key,
                      })
                    : tag.label || tag.key;

                const keyClassName = tagClassNameByKey[tag.key] ?? "";

                return (
                    <span
                        data-component-group="tag"
                        data-testid={`availability-tag-${index}`}
                        key={`${tag.key}-${index}`}
                        className={`inline-block border border-gray-300 text-center px-8 py-6 text-xs whitespace-nowrap text-gray-600 ${keyClassName} ${tagClassName}`}
                        role="listitem"
                        aria-label={formatMessage({
                            id: "product.availability.status",
                            defaultMessage:
                                "Product availability status: {status}",
                            values: { status: displayLabel },
                        })}
                    >
                        {displayLabel}
                    </span>
                );
            })}
        </div>
    );
};

export default ProductAvailabilityTags;
